<template>
    <div style="height: 93vh;width: 350px">
        <el-form-item label="编号" required>
            <el-input v-model= "id"></el-input>
        </el-form-item>
        <el-form-item label="名称" required>
            <el-input v-model= "name"></el-input>
        </el-form-item>
        <!-- <el-form-item label="文档" v-show="false">
            <el-input type="textarea" v-model="documentation"></el-input>
        </el-form-item> -->
        <el-form-item label="是否会签">
            <el-select v-model="multiinstance_type" @change="changeMultiinstance" > <!--相当于bpmn2.0标准中的isSequential-->
                <el-option v-for="item in options" :key="item.value" :value="item.value" :label="item.label" />
                <!-- <el-option label="非多实例" value="None"></el-option>
                <el-option label="同时进行" value="Parallel"></el-option>
                <el-option label="顺序进行" value="Sequential"></el-option> -->
            </el-select>
        </el-form-item>

        <!-- <el-form-item label="基数 (多实例)"  >
            <el-input v-model= "multiinstance_cardinality" type="number"></el-input>
        </el-form-item>
         -->
        <el-form-item label="会签通过人数[1-100]">
            <el-input :disabled="multiinstance_type === 'None'" v-model="multiinstance_condition" type="number"></el-input>
        </el-form-item>


        <el-form-item label="表单标识(非表达式)" v-if="$route.query.busCode !== 'user_defined '"  required>
            <el-input v-model= "formKey" ></el-input>
        </el-form-item>


        <el-form-item label="任务派遣" v-if="$route.query.busCode === 'user_defined '">
            <div class="flex">
                <!-- <el-select v-model= "excuteRoleModel.groupRoleType" filterable placeholder="请选择" style="margin-right:4px">
                    <el-option
                    v-for=" p in positions"
                    :key="p.code"
                    :label="p.name"
                    :value="p.code">
                    </el-option>
                </el-select> -->
                <el-link type="primary" @click="selectExcuteRole">选择人员</el-link>
                <div>
                    <!-- <p></p> -->
                    <div>已选人员：{{ excuteRoleModel.excuteDatas.map(v => v.userName).join('，') }}</div>
                </div>
            </div>
        </el-form-item>


        <el-form-item label="指定人(表达式)" v-if="$route.query.busCode !== 'user_defined '" required>
            <el-input v-model= "assignUserExp" ></el-input>
        </el-form-item>

        <!--人员选择-->  
        <el-dialog title="人员弹出框" :visible.sync="selectOff" width="80%">
            <selectPerson :itemData='itemData' :selectOff="selectOff" @initLoadData="initLoadData" @personSubmit="personSubmit"></selectPerson>
        </el-dialog>
    </div>
</template>
<script>
const forEach = require('lodash/forEach');
import {findObjFromArrayByField,isNeedUpdate} from './js/util/CommonUtils'; 
import bpmnHelper from './js/helper/BpmnHelper';
// import {NodeTypeMap,TxTypeMap} from '../../static/js/static'; 
//import {userReq} from '../../assets/js/public'; 
import selectPerson from "./selectPerson/selectPerson_v.vue";
const elementHelper = require('./js/helper/ElementHelper');
// 用户任务属性组件
export default {
    props:['element'],
    inject: ['bpmnModeler'],
    components: {
        selectPerson
    },
    data(){
        return {
            modeling: '',
            id: this.element.id || '',
            name: '',
            formKey:'',
            assignUserExp:'',
            selectOff:false,
            documentation: '',
            multiinstance_type: '',
            multiinstance_collection: '',
            multiinstance_condition: '',
            // multiinstance_cardinality: '',
            multiinstance_variable: '',
            // 原子节点属性
            positions:[],
            priority:'',
            excuteRoleModel:{
                groupRoleType:'',
                sysPostCode:'',
                excuteDatas:[] //[{userId:42,userName:'黄华'}]
            },
            itemData: {
                //选人插件配置项
                tabs: [
                { name: "用户", index: "0" },
                ],
                tabFouce: "0",
                data: [],
             },
            candidateGroups: 0,
            options: [
                { value: 'None', label: '非会签' }
            ]
        }
    },
    methods:{
       
    },
    mounted() {

        if(this.$route.query.busCode === 'user_defined ') {
            this.options.push(
                { value: 'Parallel', label: '同时会签' },
                { value: 'Sequential', label: '顺序会签' },
            )
        }
        const bpmnModeler = this.bpmnModeler();
        this.modeling = bpmnModeler.get('modeling');
        this.initLoadUserTypes();
        this.loadExcuteRoleModel();
    },
    methods:{
        // 初始化数据
        initLoadData(successBack){
            let _this = this;
            if(successBack 
                && typeof successBack == 'function'){
                successBack(_this.excuteRoleModel);
            }
        },
        initLoadUserTypes:function(){
            // this.reqGet(userReq.groupRoleTypes,{},(dataResult)=>{
            //     this.positions = dataResult;
            //     console.log(dataResult)
            // });
        },
        // 改变角色类型
        changeGroupRoleType:function(key){
            this.excuteRoleModel.groupRoleType = key;
        },//加载执行属性

        loadExcuteRoleModel:function(){
            const { businessObject } = this.element;
            if(businessObject){
                let executeRole = this.element.businessObject.executeRole;
                if(executeRole){
                    this.excuteRoleModel = JSON.parse(executeRole);
                    console.log(`加载执行属性：${executeRole}`)
                }       
            }
        },
        selectExcuteRole:function(){
            this.choicePerson();
            this.itemData.tabFouce=this.excuteRoleModel.groupRoleType+"";
        },//选择办理人
        choicePerson:function(){ 
            this.selectOff=true;
        },
        // 人员提交
        personSubmit(val){
            this.selectOff=false;   
            // 设置角色人员
            if( 0 == this.excuteRoleModel.groupRoleType 
                || 1== this.excuteRoleModel.groupRoleType){
                    this.excuteRoleModel.excuteDatas = [];
                    val.map(valObj => {
                        let excuteData = {
                                 orgId:valObj.orgId,
                                 orgName:valObj.orgName,
                                 depId:valObj.depId,
                                 depName:valObj.depName,
                                 postId:valObj.postId,
                                 postName:valObj.postName,
                                 userId:valObj.userId,
                                 userName:valObj.userName
                        };
                        this.excuteRoleModel.excuteDatas.push(excuteData);
                    });

                // 如果绘制流程图中未指定人，则动态从流程中获取
                if(this.excuteRoleModel.excuteDatas.length > 0){
                    this.changeGroupRoleType(0);
                    console.log("已指定人，取流程图上的人员");
                }else{
                    this.changeGroupRoleType(5);
                    console.log("未指定人,实例人员");
                    this.assignUserExp = '';
                }

            }//设置值 
            else {
                    this.excuteRoleModel.sysPostCode = val;
            }
            // 更新userTask
            if(this.element.type=="bpmn:UserTask"){

                // 如果绘制流程图中未指定人，则动态从流程中获取
                if(this.excuteRoleModel.excuteDatas.length > 0){
                    this.changeGroupRoleType(0);
                    console.log("已指定人，取流程图上的人员");
                }else{
                    this.changeGroupRoleType(5);
                    console.log("未指定人,实例人员");
                    this.assignUserExp = '';
                }

                let modelJson = JSON.stringify(this.excuteRoleModel);
                this.modeling.updateProperties(this.element,{'executeRole': modelJson});

                console.log(`更新userTask:${modelJson}`);

            }
        },
        // 创建多实例
        changeMultiinstance(){
            // console.log(this.multiinstance_condition)
            // console.log(this.multiinstance_type)
            if(this.multiinstance_type === 'None') {
                this.multiinstance_condition = ''
            }
            try {
                const bpmnModeler = this.bpmnModeler();
                const modeling = bpmnModeler.get('modeling');
                if('None' === this.multiinstance_type){
                    modeling.updateProperties(this.element, { loopCharacteristics: null});
                    this.assignUserExp = '';
                } else {
                    // 先清空
                    const moddle = bpmnModeler.get('moddle');
                    const bpmnFactory = bpmnModeler.get('bpmnFactory');
                    let loopCharacteristics = moddle.create('bpmn:MultiInstanceLoopCharacteristics');
                    // 循环次数
                    /**
                    if(this.multiinstance_cardinality){
                        let loopCardinality = elementHelper.createElement('bpmn:FormalExpression',{ body:this.multiinstance_cardinality}, loopCharacteristics, bpmnFactory);
                         loopCharacteristics['loopCardinality'] = loopCardinality;
                    }
                     */
                    // 条件

                    let multiinstance_condition_exp = '${nrOfCompletedInstances >= ' + this.multiinstance_condition + '}';

                    // 条件
                    let completionCondition = elementHelper.createElement('bpmn:FormalExpression', { body:multiinstance_condition_exp}, loopCharacteristics, bpmnFactory);



                    //let completionCondition = elementHelper.createElement('bpmn:FormalExpression', { body:'${nrOfCompletedInstances >= '+this.multiinstance_condition+'}'}, loopCharacteristics, bpmnFactory);
                    loopCharacteristics['completionCondition'] = completionCondition;
                    loopCharacteristics['collection'] = '${multi_instance_userIds}';
                    loopCharacteristics['elementVariable'] = 'multi_user_assignee';
                    this.assignUserExp = '${multi_user_assignee}';
                    if('Parallel' === this.multiinstance_type){
                        loopCharacteristics['isSequential'] = false;
                        modeling.updateProperties(this.element, { loopCharacteristics: loopCharacteristics });
                    } else if('Sequential' === this.multiinstance_type){
                        loopCharacteristics['isSequential'] = true;
                        modeling.updateProperties(this.element, { loopCharacteristics: loopCharacteristics });
                    }
                }
                
            }catch(e){
                console.log('创建多实例',e);
            }
        },
    },
    watch:{
        name: {
            handler(newVal, oldVal) {
                this.modeling.updateProperties(this.element,{
                    name: newVal
                });
            }
        },
        //监视元素变化
        element:{
            deep: true,
            immediate: true, 
             handler(newVal,oldVal){
                //  debugger;
                 if(newVal.type == 'bpmn:UserTask') {
                     const bpmnModeler = this.bpmnModeler();
                     const modeling = bpmnModeler.get('modeling');
                     const businessObject = newVal.businessObject;
                     this.name = businessObject.name;
                     this.assignUserExp = businessObject.assignee;
                     this.formKey = businessObject.get('formKey');
                     // 原子
                     const candidateGroupsTemp = businessObject.get('candidateGroups');
                     // 解决后端反显和切换节点反显candidateGroupsTemp类型不一致问题
                    if(candidateGroupsTemp && candidateGroupsTemp.length > 0) {
                        if(Array.isArray(candidateGroupsTemp)) {
                            //切换节点反显
                            this.candidateGroups = businessObject.get('candidateGroups');
                        } else {
                            //后端反显
                            this.candidateGroups = businessObject.get('candidateGroups').split(',');
                        }
                    }
                     this.multiinstance_type = businessObject.get('multiinstance_type') || 'None';
                     this.multiinstance_condition = businessObject.get('multiinstance_condition') || '';
                     //this.multiinstance_cardinality = businessObject.get('multiinstance_cardinality') || '';
                     //modeling.updateProperties(newVal,{'multiinstance_cardinality':this.multiinstance_condition});
                     modeling.updateProperties(newVal,{'multiinstance_type':this.multiinstance_type});
                     modeling.updateProperties(newVal,{'multiinstance_condition':this.multiinstance_condition});

                     // 已选人员回显
                     try {
                         let obj = JSON.parse(newVal.businessObject.executeRole)
                         this.$set(this.excuteRoleModel, 'excuteDatas', obj.excuteDatas)
                     }catch(error) {
                         this.$set(this.excuteRoleModel, 'excuteDatas', [])
                     }
                 }
             }
        },
        formKey:{
            handler(newVal,oldVal){
                this.modeling.updateProperties(this.element,{'formKey':newVal});
            }
        },
        multiinstance_type: {
            handler(newVal, oldVal) {
                this.modeling.updateProperties(this.element,{'multiinstance_type':newVal});
            }
        },
        multiinstance_collection: {
            handler(newVal, oldVal) {
                this.modeling.updateProperties(this.element,{'multiinstance_collection':newVal});
            }
        },
        multiinstance_condition: {
            handler(newVal, oldVal) {
                this.modeling.updateProperties(this.element,{'multiinstance_condition':newVal});
                this.changeMultiinstance();
            }
        },
        /**
        multiinstance_cardinality:{
            handler(newVal, oldVal) {
                this.modeling.updateProperties(this.element,{'multiinstance_cardinality':newVal});
            }
        },
         */
        priority: {
            handler(newVal, oldVal) {
                this.modeling.updateProperties(this.element,{'priority':newVal});
            }
        },
        candidateGroups: {
            handler(newVal,oldVal){
                this.modeling.updateProperties(this.element,{'candidateGroups':newVal});
            }
        },
        assignUserExp: {
            handler(newVal,oldVal){
                this.modeling.updateProperties(this.element,{'assignee':newVal});
            }
        }
    }
}
</script>
<style>
</style>